export class CopyHelpers {
  static deepCopy(obj: any): any {
    return JSON.parse(JSON.stringify(obj));
  }
}
